import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScoreBarNG from './../../../ScoreBarNG/ScoreBarNG';
import ScoreBarTypes from './../../../../constants/ScoreBarTypes';
import style from './style/competencyscorebar.scss';

class CompetencyScoreBar extends Component {
    getLabelText(competency) {
        if (!competency.score) {
            return '';
        }
        if (!competency.cutoff) {
            return competency.label || '';
        }
        if (competency.score < competency.cutoff) {
            return this.props.i18n.report_tested_level_indicator_text_failed;
        }
        return this.props.i18n.report_tested_level_indicator_text_success;
    }

    render() {
        const { competency } = this.props;

        if (!competency || !Object.keys(competency).length) {
            return null;
        }

        return (<section className={ style.competencyScoreBarWrapper }>
            <ScoreBarNG
                scoreMin={ 1 }
                scoreMax={ 5 }
                scoreValue={ competency.score }
                fill={ false }
                scoreBarType={ ScoreBarTypes.CUTOFF }
                digits={ 2 }
                valueLabelDisplay={ 'off' }
                cutOff={ competency.cutoff }
                disabled={ true }
            />
                { this.getLabelText(competency) }
        </section>
        );
    }
}

export default CompetencyScoreBar;

CompetencyScoreBar.propTypes = {
    competency: PropTypes.object,
    i18n: PropTypes.object
};
